import { PxApiError } from './PxApiError';
import { LoggerTexts } from '../LoggerTexts';

export class ConfigurationLoadingError extends PxApiError {
	_url: URL;
	_statusCode?: number;
	_initialError?: Error;
	constructor(url: URL, statusCode?: number, initialError?: Error, message?: string) {
		const formattedMessage = message ? message.trim() : '';
		/* istanbul ignore next */ //Coverage works correctly with ES6
		super(formattedMessage);

		if (Error.captureStackTrace) {
			Error.captureStackTrace(this, ConfigurationLoadingError);
		}
		this.name = 'PxApi.ConfigurationLoadingError';
		this._url = url;
		this._statusCode = statusCode;
		this._initialError = initialError;

		let messageText = LoggerTexts.CFG_LOADER.ERROR_HEADER;
		if (this._url && !this._statusCode) {
			messageText += ` from ${this._url} failed with an unknown error.`;
		} else if (this._url && this._statusCode) {
			messageText += ` from ${this._url} failed with ${this._statusCode}.`;
		}
		if (formattedMessage) {
			messageText += ` ${formattedMessage}`;
		}
		this.message = messageText;
	}
}
